import { useQuery } from "@tanstack/react-query";
import { AffiliateApi } from "@/api/affiliates";
import { QueryKey } from "@/utils";
import { useNotify } from "react-admin";

export const useAffiliatePaymentSum = (
  affiliateId: string,
  year?: number,
  month?: number,
) => {
  const notify = useNotify();
  const enabled = !!affiliateId && !!year && !!month;

  const { data, isPending, isError, error } = useQuery({
    queryKey: [QueryKey.AFFILIATE_PAYMENT_AMOUNT, affiliateId, year, month],
    queryFn: () =>
      AffiliateApi.getAffiliatePaymentSum({
        affiliateId,
        year: year!,
        month: month!,
      }),
    enabled,
    select: (data) => (data?.totalUnpaid ? data.totalUnpaid / 100 : 0),
  });

  if (isError) {
    notify(error, { type: "error" });
  }

  return {
    paymentAmount: data,
    isLoadingAmount: enabled && isPending,
  };
};
